<script lang="ts">
  import ChoiceList from '../lib/ui/ChoiceList.svelte';
  import Field from '../lib/ui/Field.svelte';
  import type { HeadquartersContact } from '../lib/api';
  import type { ContactSearch } from '../lib/contact-search.svelte';

  interface Props {
    search: ContactSearch;
    chosen: HeadquartersContact | null;
    onChoose: (contact: HeadquartersContact) => void;
    isListed?: (contact: HeadquartersContact) => boolean;
  }

  let { search, chosen, onChoose, isListed = () => false }: Props = $props();
</script>

<Field label="Contato do Desenrola HQ" hint="Cliente da Desenrola, pelo nome ou telefone. Contato novo se cadastra no HQ">
  <input type="search" placeholder="Buscar contato" bind:value={search.term} />
</Field>
<ChoiceList
  name="contact"
  items={search.results}
  key={(contact) => contact.id}
  isChosen={(contact) => chosen?.id === contact.id}
  isDisabled={isListed}
  title={(contact) => contact.name}
  monospaceSubtitle
  subtitle={(contact) => (isListed(contact) ? 'Já recebe este relatório' : (contact.identification ?? 'Sem telefone'))}
  emptyText={search.isSearching ? 'Nenhum contato com esse nome ou telefone.' : ''}
  {onChoose}
/>
